var exports = {
  "o": "x2b2fbebb--0ef38e--block",
  "M": "x2b2fbebb--0ef38e--block-shown",
};

module.exports = exports;
